/**
 * Centralised, typed access to build-time environment configuration.
 * All values are injected by Create React App from `REACT_APP_*` env vars.
 */
export const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3000/api',
  publicUrl: process.env.REACT_APP_PUBLIC_URL || 'menu-tiger-translator',
  appName: 'Menu Tiger Translator',
};

/** LocalStorage key under which the JWT access token is persisted. */
export const TOKEN_STORAGE_KEY = `token-${config.publicUrl}`;
